var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWidgets = function SvgWidgets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 16.4446C5.33398 15.831 5.83145 15.3335 6.4451 15.3335H9.77843C10.3921 15.3335 10.8895 15.831 10.8895 16.4446V19.7779C10.8895 20.3916 10.3921 20.8891 9.77843 20.8891H6.4451C5.83145 20.8891 5.33398 20.3916 5.33398 19.7779V16.4446Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11133 4.22244C3.11133 3.60879 3.60879 3.11133 4.22244 3.11133H9.778C10.3916 3.11133 10.8891 3.60879 10.8891 4.22244V9.778C10.8891 10.3916 10.3916 10.8891 9.778 10.8891H4.22244C3.60879 10.8891 3.11133 10.3916 3.11133 9.778V4.22244Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.334 16.4446C15.334 15.831 15.8314 15.3335 16.4451 15.3335H19.7784C20.3921 15.3335 20.8895 15.831 20.8895 16.4446V19.7779C20.8895 20.3916 20.3921 20.8891 19.7784 20.8891H16.4451C15.8314 20.8891 15.334 20.3916 15.334 19.7779V16.4446Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.334 6.44461C15.334 5.83096 15.8314 5.3335 16.4451 5.3335H19.7784C20.3921 5.3335 20.8895 5.83096 20.8895 6.44461V9.77794C20.8895 10.3916 20.3921 10.8891 19.7784 10.8891H16.4451C15.8314 10.8891 15.334 10.3916 15.334 9.77794V6.44461Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWidgets;